// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox[data-v-6de7ea82] {\n  height: calc(-112px + 100vh);\n}", ""]);
// Exports
module.exports = exports;
